import moment from "moment";
import InfoDialog from "@/components/InfoDialog";
import { mapGetters } from "vuex";

// BE-1121: the operator and operator-group forms already emit updateRouterParams
// on back, they were just never listed here, so the button never rendered.
const BACK_BUTTON_ROUTES = [
  "View Customer Owned Equipment Details",
  "View Rental Equipment Details",
  "Update Service Templates",
  "Update Geofences",
  "editGroup",
  "editUser",
  "View Customer Details",
  "View Birch Details",
  "Access Control Operators Management",
  "Edit Access Control Operators Management",
  "Group Control Operators Management",
  "Edit Group Control Operators Management",
];

export default {
  name: "pageheader",
  components: { InfoDialog },
  props: [
    "input",
    "viewTicket",
    "jiraKey",
    "priority",
    "assignee",
    "reportedBy",
    "reportedOn",
    "dataIntegrity",
  ],
  data() {
    return {
      openedPanel: [],
      isExpanded: false,
      showbanner: true,
      isShowBackBtn: true,
      customerAccessCode: "",
      allRentedFleet: false,
      showAccessControlOperatorInfo: false,
      showEnabledOnRentedModeMessage:
        "Access control will be applied to all rented equipment.",
      showDisabledOnRentedModeMessage:
        "Access control will only be applied to equipment through access control groups, operators or jobsites.",
    };
  },
  computed: {
    ...mapGetters(["companyIdDropdown", "customerAccessCodes"]),
  },
  watch: {
    companyIdDropdown() {
      this.handleCustomerAccessCodes();
    },
  },
  filters: {
    formatDate: function (value) {
      if (value) {
        const format = "YYYY-MM-DD";
        return moment(value).format(format);
      }
    },
    lowercase: function (value) {
      if (value) {
        return value.toLowerCase();
      }
    },
  },
  mounted() {
    this.handleCustomerAccessCodes();
    if (BACK_BUTTON_ROUTES.includes(this.$route.name)) {
      this.isShowBackBtn = true;
    } else {
      this.isShowBackBtn = false;
    }
  },
  methods: {
    // Shows the selected customer's master code and mode. Used to appear on two
    // of the access-control screens; now on all of them, and refreshed when the
    // toolbar customer changes instead of only on mount.
    handleCustomerAccessCodes() {
      this.showAccessControlOperatorInfo = false;
      this.customerAccessCode = "";
      this.allRentedFleet = false;
      if (!this.$route.path.startsWith("/access-control")) return;
      (this.customerAccessCodes || []).forEach((code) => {
        if (code.customerId == this.companyIdDropdown) {
          this.showAccessControlOperatorInfo = true;
          this.customerAccessCode = code.code;
          this.allRentedFleet = code.allRentedFleet;
        }
      });
    },
    handleToggle() {
      if (this.isExpanded) {
        this.openedPanel = [0];
        this.showbanner = false;
      } else {
        this.openedPanel = [1];
        this.showbanner = true;
      }
    },
    toggleClick() {
      this.isExpanded = !this.isExpanded;
      this.handleToggle();
    },
    openModal() {
      this.$refs.modal.showModal();
    },
    contractsPage() {
      this.$router.push("/contracts");
    },
    updateRouterParams() {
      this.$emit("updateRouterParams");
    },
  },
};
